/**
 * Labstep
 *
 * @module constants/analytics
 * @desc Static configuration for organization analytics dashboard
 */

export enum ORGANIZATION_ANALYTICS_INTERVAL {
  daily = 'daily',
  monthly = 'monthly',
  weekly = 'weekly',
}

export enum ORGANIZATION_ANALYTICS_METRIC {
  user_engagement_active_users = 'user_engagement_active_users',
  user_engagement_total_activity = 'user_engagement_total_activity',
  module_usage_device = 'module_usage_device',
  module_usage_experiment_workflow = 'module_usage_experiment_workflow',
  module_usage_order_request = 'module_usage_order_request',
  module_usage_protocol_collection = 'module_usage_protocol_collection',
  module_usage_resource = 'module_usage_resource',
}

export const ORGANIZATION_ANALYTICS_METRICS = [
  ORGANIZATION_ANALYTICS_METRIC.user_engagement_active_users,
  ORGANIZATION_ANALYTICS_METRIC.user_engagement_total_activity,
  ORGANIZATION_ANALYTICS_METRIC.module_usage_device,
  ORGANIZATION_ANALYTICS_METRIC.module_usage_experiment_workflow,
  ORGANIZATION_ANALYTICS_METRIC.module_usage_order_request,
  ORGANIZATION_ANALYTICS_METRIC.module_usage_protocol_collection,
  ORGANIZATION_ANALYTICS_METRIC.module_usage_resource,
];
